import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Kids, always remember to clear your intervals",
  "description": "",
  "published": "2014-11-05T00:00:00.000Z",
  "redirect_from": ["/blog/kids-always-remember-to-clear-your-intervals/swizec/6614"],
  "categories": "JavaScript, Node.js, socket.io, Uncategorized",
  "hero": "./img/images-23704.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Making fake demo graphs is always fun. Here you are, making a graph without data, generating random datapoints, trying to make it as realistic as possible.`}</p>
    <p>{`Two days ago I was failing at the same.`}</p>
    <p>{`It sounds simple, right? To produce a random graph, you generate random data. Something like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var data = _.range(250).map(function () {
  return Math.round(Math.random() * 100);
});
`}</code></pre>
    <p>{`And your graph will look like this:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "504px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/3cc3a78384c0b409877b2d0c3eea7b82/08115/images-23704.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.33632286995517%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'301\\'%20viewBox=\\'0%200%20400%20301\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M8%208L7%20151v144l1-128V40h385V7H201L8%208m385%20159\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3cc3a78384c0b409877b2d0c3eea7b82/ca0a1/images-23704.webp 223w", "/static/3cc3a78384c0b409877b2d0c3eea7b82/75680/images-23704.webp 445w", "/static/3cc3a78384c0b409877b2d0c3eea7b82/062aa/images-23704.webp 504w"],
                "sizes": "(max-width: 504px) 100vw, 504px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3cc3a78384c0b409877b2d0c3eea7b82/e92b6/images-23704.png 223w", "/static/3cc3a78384c0b409877b2d0c3eea7b82/e66bf/images-23704.png 445w", "/static/3cc3a78384c0b409877b2d0c3eea7b82/08115/images-23704.png 504w"],
                "sizes": "(max-width: 504px) 100vw, 504px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3cc3a78384c0b409877b2d0c3eea7b82/08115/images-23704.png",
                "alt": "Completely random graph",
                "title": "Completely random graph",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Completely random graph`}</figcaption>{`
  `}</figure></p>
    <p>{`Well, that doesn't look realistic at all. Crazy spikes, deep valleys ... if a real-world system behaved like this you would be very concerned for its wellbeing. This won't do for a demo.`}</p>
    <p>{`And besides, you wanted a live graph anyway.`}</p>
    <p>{`So you move data generation into the backend and hook it up with `}<a parentName="p" {...{
        "href": "http://socket.io/",
        "title": "Socket.io"
      }}>{`socket.io`}</a>{`. Then you make a function that generates one datapoint every `}<inlineCode parentName="p">{`250ms`}</inlineCode>{`.`}</p>
    <p>{`Data generation looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`io.on("connection", function (socket) {
  setInterval(function () {
    socket.emit("cpu", update());
  }, 250);

  function update() {
    return Math.round(Math.random() * 100);
  }
});
`}</code></pre>
    <p>{`Your graph now looks like this:`}</p>
    <p><img parentName="p" {...{
        "src": "/0abe9a60789197ee98cd57793a9a5d09/images-23705.gif",
        "alt": "Moving random graph",
        "title": "Moving random graph"
      }}></img></p>
    <p>{`Yay! It moves!`}</p>
    <p>{`But still too random to look realistic. A `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Central_processing_unit",
        "title": "Central processing unit"
      }}>{`CPU`}</a>{` that behaves like that is in serious trouble!`}</p>
    <p>{`What if instead of producing random values, we produced random changes to existing values? That could work. Remember the previous state, make a tiny random change.`}</p>
    <p>{`Data generation now looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`io.on('connection', function (socket) {
    var previous = 0;

    setInterval(function () {
        previous = update(previous);
        socket.emit('cpu', previous);
    }, 250);

    function (previous) {
        previous += Math.random()*10-5;
        if (previous > 100) previous = 100;
        if (previous < 0) previous = 0;

        return Math.round(previous);
    }
});
`}</code></pre>
    <p>{`And the graph looks like this:`}</p>
    <p><img parentName="p" {...{
        "src": "/a2a1752254bc016b2cf0ae03377835af/images-23706.gif",
        "alt": "Fixed random graph, 1",
        "title": "Fixed random graph, 1"
      }}></img></p>
    <p>{`Or like this:`}</p>
    <p><img parentName="p" {...{
        "src": "/ce62a74e7d8678cc72300f3fb4acd281/images-23707.gif",
        "alt": "Fixed random graph, 2",
        "title": "Fixed random graph, 2"
      }}></img></p>
    <p>{`Or even like this:`}</p>
    <p><img parentName="p" {...{
        "src": "/4a4759a5314fcb7ec8ea6e821768970e/images-23708.gif",
        "alt": "Fixed random graph, 3",
        "title": "Fixed random graph, 3"
      }}></img></p>
    <p>{`Wait ... what? That's even worse than before! How is this possible, the value changes on each step are `}<em parentName="p">{`tiny`}</em>{`?`}</p>
    <p>{`And I wrecked my brain and wrecked my brain and then wrecked my brain some more. Refreshed the page many times. Rewrote the data generating function many times. Nothing I tried worked. The graph looked more sporadic than ever.`}</p>
    <p>{`Can you spot the error?`}</p>
    <p>{`The clue lies in those graphs moving faster and faster with each refresh. Something fucky is going on - the uncleared setInterval.`}</p>
    <p>{`You see, that backend node.js process is persistent. The 250 millisecond interval doesn't just go away when you refresh the page. Oh no, it's still there, waiting for you, stalking its prey, hunting.`}</p>
    <p>{`And because socket.io does evertyhing in its power to be more reliable than not, it will reconnect old sockets because hey, you probably just have spotty wi-fi. But we also started a new `}<inlineCode parentName="p">{`setInterval`}</inlineCode>{` on every `}<inlineCode parentName="p">{`connection`}</inlineCode>{` event.`}</p>
    <p>{`Yeah.`}</p>
    <p>{`That's not a single random function acting funny, that's a whole bunch of them!`}</p>
    <p>{`If we fix the backend code to look like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`io.on('connection', function (socket) {
    var previous = 0;

    var interval = setInterval(function () {
        previous = update(previous);
        socket.emit('cpu', previous);
    }, 250);

    function (previous) {
        previous += Math.random()*10-5;
        if (previous > 100) previous = 100;
        if (previous < 0) previous = 0;

        return Math.round(previous);
    }

    socket.on('disconnect', function () {
        clearInterval(interval);
    });
});
`}</code></pre>
    <p>{`The graph looks like this:`}</p>
    <p><img parentName="p" {...{
        "src": "/7022f325d8a6540a3051815d14d119dd/images-23710.gif",
        "alt": "Moving graph, good",
        "title": "Moving graph, good"
      }}></img></p>
    <p>{`And all is right in the world.`}</p>
    <p>{`You're happy, your boss is happy, your graph looks like it could be real but isn't. Acting.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      